import request from '@/utils/analyticsRequest'

export function listUnansweredQuestions(params = {}) {
  return request({
    url: '/api/v1/ghl/ai/unanswered-questions',
    method: 'get',
    params
  })
}

export function dismissUnansweredQuestion(id) {
  return request({
    url: `/api/v1/ghl/ai/unanswered-questions/${id}/dismiss`,
    method: 'post'
  })
}
